import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Users, Linkedin, Twitter, Github } from 'lucide-react';

const teamMembers = [
  {
    id: 1,
    name: 'John Anderson',
    role: 'CEO & Founder',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    bio: 'Visionary leader with 15+ years in software development',
    social: { linkedin: '#', twitter: '#', github: '#' }
  },
  {
    id: 2,
    name: 'Sarah Martinez',
    role: 'CTO',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    bio: 'Technology expert specializing in cloud architecture',
    social: { linkedin: '#', twitter: '#', github: '#' }
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Lead Developer',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    bio: 'Full-stack developer with passion for AI integration',
    social: { linkedin: '#', twitter: '#', github: '#' }
  },
  {
    id: 4,
    name: 'Emily Roberts',
    role: 'UI/UX Director',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
    bio: 'Award-winning designer focused on user experience',
    social: { linkedin: '#', twitter: '#', github: '#' }
  },
  {
    id: 5,
    name: 'David Kumar',
    role: 'DevOps Engineer',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    bio: 'Infrastructure specialist with expertise in cloud deployment',
    social: { linkedin: '#', twitter: '#', github: '#' }
  },
  {
    id: 6,
    name: 'Lisa Thompson',
    role: 'Project Manager',
    image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
    bio: 'Agile expert ensuring seamless project delivery',
    social: { linkedin: '#', twitter: '#', github: '#' }
  }
];

export const Team = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-6">
        {/* Hero Section */}
        <div className="max-w-4xl mx-auto text-center mb-16 animate-slide-up">
          <div className="w-20 h-20 bg-[rgba(0,168,255,0.2)] rounded-2xl flex items-center justify-center mx-auto mb-6" style={{ boxShadow: '0 0 30px rgba(0,168,255,0.5)' }}>
            <Users className="text-[#00a8ff]" size={40} style={{ filter: 'drop-shadow(0 0 10px #00a8ff)' }} />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold led-text animate-led-pulse mb-6" style={{ textShadow: '0 0 20px #00a8ff, 0 0 40px #4cd3ff' }}>
            OUR TEAM
          </h1>
          <p className="text-xl text-[#00a8ff]" style={{ textShadow: '0 0 10px #00a8ff' }}>
            Meet the talented professionals behind Max Bien Software
          </p>
        </div>

        {/* Team Grid - ALWAYS VISIBLE */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {teamMembers.map((member, idx) => (
            <Card key={member.id} className="group bg-[rgba(30,64,98,0.7)] border-2 border-[#00a8ff] rounded-xl overflow-hidden hover:shadow-[0_0_40px_#00a8ff] transition-all duration-300 hover:-translate-y-4" style={{ boxShadow: '0 0 15px rgba(0,168,255,0.3)' }}>
              <div className="relative overflow-hidden aspect-square">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  style={{ filter: 'brightness(0.8)' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[rgba(10,37,64,0.95)] via-transparent to-transparent"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2 led-text group-hover:text-[#00a8ff] transition-colors" style={{ textShadow: '0 0 10px #00a8ff' }}>
                  {member.name}
                </h3>
                <div className="text-[#00a8ff] font-bold mb-4" style={{ textShadow: '0 0 8px #00a8ff' }}>
                  {member.role}
                </div>
                <p className="text-[#00a8ff] text-sm mb-6" style={{ textShadow: '0 0 5px #00a8ff' }}>
                  {member.bio}
                </p>
                <div className="flex space-x-4">
                  <a href={member.social.linkedin} className="w-10 h-10 bg-[rgba(0,168,255,0.2)] border border-[#00a8ff] rounded-lg flex items-center justify-center hover:bg-[#00a8ff] hover:scale-110 transition-all duration-300" style={{ boxShadow: '0 0 10px rgba(0,168,255,0.3)' }}>
                    <Linkedin className="text-[#00a8ff] hover:text-[#0a2540]" size={18} />
                  </a>
                  <a href={member.social.twitter} className="w-10 h-10 bg-[rgba(0,168,255,0.2)] border border-[#00a8ff] rounded-lg flex items-center justify-center hover:bg-[#00a8ff] hover:scale-110 transition-all duration-300" style={{ boxShadow: '0 0 10px rgba(0,168,255,0.3)' }}>
                    <Twitter className="text-[#00a8ff] hover:text-[#0a2540]" size={18} />
                  </a>
                  <a href={member.social.github} className="w-10 h-10 bg-[rgba(0,168,255,0.2)] border border-[#00a8ff] rounded-lg flex items-center justify-center hover:bg-[#00a8ff] hover:scale-110 transition-all duration-300" style={{ boxShadow: '0 0 10px rgba(0,168,255,0.3)' }}>
                    <Github className="text-[#00a8ff] hover:text-[#0a2540]" size={18} />
                  </a>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Join Us Section */}
        <Card className="bg-[rgba(30,64,98,0.7)] border-2 border-[#00a8ff] rounded-2xl p-12 text-center animate-slide-up" style={{ boxShadow: '0 0 30px rgba(0,168,255,0.3)' }}>
          <h2 className="text-4xl font-bold led-text mb-6" style={{ textShadow: '0 0 15px #00a8ff' }}>
            JOIN OUR TEAM
          </h2>
          <p className="text-[#00a8ff] text-xl mb-8" style={{ textShadow: '0 0 8px #00a8ff' }}>
            We're always looking for talented individuals to join our mission
          </p>
          <a href="/contact">
            <button className="bg-[#00a8ff] text-[#0a2540] hover:bg-[#4cd3ff] font-bold px-8 py-4 text-lg rounded-lg transition-all duration-300 hover:scale-110" style={{ boxShadow: '0 0 30px #00a8ff' }}>
              View Open Positions
            </button>
          </a>
        </Card>
      </div>
    </div>
  );
};
